/**
 * Template @react-pdf/renderer
 * Résultats 4ème Année de Pharmacie - Université Kankou Moussa
 *
 * Installation : npm install @react-pdf/renderer
 * Usage        : <ResultatsPharmaciePDF data={students} />
 *                ou appeler generatePDF() pour déclencher le téléchargement
 */

import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Canvas,
  pdf,
} from "@react-pdf/renderer";

// ─── Constantes ───────────────────────────────────────────────────────────────

const BORDER     = "0.5pt solid #000";
const BORDER_CLR = "#000000";
const BORDER_W   = 0.5;
const FONT_SIZE  = 6.5;
const HEADER_H   = 72;
const HEADER_BG  = "#BDD7EE";
const TOTAL_BG   = "#FFF2CC";

// Facteur empirique : largeur d'un caractère Helvetica ≈ 0.5 × fontSize
const CHAR_W     = FONT_SIZE * 0.50;
const CELL_PAD   = 4; // padding horizontal total (gauche + droite)

// Page A4 landscape : 841.89pt - 2×18pt marges = 805.89pt utiles
const PAGE_W     = 841.89 - 18 * 2;

// ─── Données ──────────────────────────────────────────────────────────────────

const MATIERES = [
  "Pharmacologie gén.",
  "Hydrologie",
  "Phytochimie",
  "Parasito-Myco.",
  "Pharmac. Chim. & Bot.",
  "Santé Pub.",
  "Hématologie clinique",
  "Eau de la Santé",
  "Toxicol. Gén.",
  "Droit et éthique",
];

const STUDENTS = [
  { no: 1,  prenom: "Kadidja Sékou",            nom: "GUINDO",      s: "F", notes: [14.5,18.25,19.75,20,17.5,16,15.5,19.5,19.5,13],   total: 189.5,  moy: 17.23 },
  { no: 2,  prenom: "Kadidiatou",               nom: "MANGANE",     s: "F", notes: [17,17.25,18.5,19,20,14,16.5,19,17.75,16.5],        total: 188.08, moy: 17.10 },
  { no: 3,  prenom: "Kadidiatou",               nom: "DOUCOURE",    s: "F", notes: [19,18.25,17.5,20,15.67,14,15.5,17,19.25,15],       total: 187.17, moy: 17.02 },
  { no: 4,  prenom: "Aminata",                  nom: "COULIBALY",   s: "F", notes: [15,17.25,18,19.5,20,16.67,13,18.5,18,19.25],       total: 178.33, moy: 16.21 },
  { no: 5,  prenom: "Fatoumata",                nom: "FOFANA",      s: "F", notes: [7.5,16.75,18,17,17.83,14,17.5,18,19.75,12.5],      total: 178.17, moy: 16.20 },
  { no: 6,  prenom: "Khadidiatou Abass",        nom: "KEÏTA",       s: "M", notes: [16,16.25,12.5,20,17.67,15,14,18,19.5,12],          total: 176.92, moy: 16.08 },
  { no: 7,  prenom: "Idrissa Toutougno",        nom: "DIARRA",      s: "F", notes: [17,16.25,12.5,20,16.67,14,16,19,19.5,12],          total: 176.42, moy: 16.04 },
  { no: 8,  prenom: "Djénéba",                  nom: "DIARRA",      s: "F", notes: [16,16.25,17,18,16.67,16,14,18,18.5,13.5],          total: 175.5,  moy: 15.95 },
  { no: 9,  prenom: "Coumba",                   nom: "KONE",        s: "F", notes: [8.5,17.25,18,19.5,17.5,14,17,19,17.5,11],          total: 173.33, moy: 15.76 },
  { no: 10, prenom: "Kadidiatou Issa",          nom: "YARANANGORE", s: "F", notes: [5,17.25,15,20,16.83,15,19,17,14.5,12],             total: 173.25, moy: 15.75 },
  { no: 11, prenom: "Fatoumata",                nom: "TOURE",       s: "F", notes: [5,17.25,15,20,16.83,15,19,17,14.5,12],             total: 173.25, moy: 15.75 },
  { no: 12, prenom: "Firdaoussiou",             nom: "SAMAKE",      s: "M", notes: [12,18.25,17.5,20,16.5,16,18.5,19,14.5,11],         total: 173.17, moy: 15.74 },
  { no: 13, prenom: "Daouda Daba",              nom: "SONHAYE",     s: "M", notes: [15,17.25,14.75,16,15.17,17,17,18,19.5,11],         total: 171.83, moy: 15.62 },
  { no: 14, prenom: "Nadjonbe M bebe vic",      nom: "GOUNDOUROU",  s: "F", notes: [17,18.25,19.5,13,13.83,11,16,18,15,14],            total: 171.58, moy: 15.60 },
  { no: 15, prenom: "Daouda Lamine",            nom: "SANGARE",     s: "M", notes: [13,19,17.5,13,13.83,15,15,17,15.25,11],            total: 165.58, moy: 15.05 },
  { no: 16, prenom: "Rokia",                    nom: "DIALLO",      s: "F", notes: [16,13,15,19,16.33,16,15.5,18,15,11],               total: 164.08, moy: 14.92 },
  { no: 17, prenom: "Atika",                    nom: "DRAME",       s: "F", notes: [12,17.25,13,19,16.33,16,15.5,18,15,11],            total: 163.17, moy: 14.83 },
  { no: 18, prenom: "Aminata",                  nom: "SISSOKO",     s: "F", notes: [12,17.25,15.5,17.5,16.83,15,15.5,19,19.75,8.5],   total: 163.17, moy: 14.83 },
  { no: 19, prenom: "Djibril dit Ousamane Doco",nom: "GUINDO",      s: "M", notes: [15,17.5,12.75,16,12.67,16,13,18,16.25,8],          total: 160.83, moy: 14.62 },
  { no: 20, prenom: "Alida Ibrahim",            nom: "TRAORE",      s: "F", notes: [15,17.25,15,18,15.33,11,17.5,16,18.25,11],         total: 158,    moy: 14.36 },
  { no: 21, prenom: "Aïssata Nassoun",          nom: "BALLO",       s: "F", notes: [11,13,13.25,18,18,17.5,16,14.5,18,19.25],          total: 156,    moy: 14.18 },
  { no: 22, prenom: "Mahamadou Ibrahima",       nom: "DIARRA",      s: "M", notes: [10,18.25,12.5,13.5,14,14,14.5,18,19.25,11],        total: 155.25, moy: 14.11 },
  { no: 23, prenom: "Aminata",                  nom: "CISSE",       s: "F", notes: [10,17.25,8,19,17,14,15.5,18,15.25,11],             total: 154,    moy: 14.00 },
  { no: 24, prenom: "Ourqaya",                  nom: "BOCOUM",      s: "F", notes: [11,14.25,11.5,14,15,14,17,16,13.75,11.5],          total: 153.17, moy: 13.92 },
  { no: 25, prenom: "Alcha",                    nom: "DIAGNE",      s: "F", notes: [12,16.25,11.75,16.5,16.5,12,15.5,19,18.5,11],      total: 152.75, moy: 13.89 },
  { no: 26, prenom: "Nour Koutam",              nom: "HAÏDARA",     s: "M", notes: [10,14,10,18,12.67,14,13.5,18,14.25,12.5],          total: 152.25, moy: 13.84 },
  { no: 27, prenom: "Mohamed Makono",           nom: "TOGOLA",      s: "M", notes: [5,18.25,11.5,19,16,8,16.5,16,17.75,10],            total: 152,    moy: 13.82 },
  { no: 28, prenom: "Mariam M",                 nom: "COULIBALY",   s: "F", notes: [5,17.25,10,18,15.33,13,12,18,16.25,10],            total: 151.75, moy: 13.80 },
  { no: 29, prenom: "Daouda",                   nom: "DIARRA",      s: "M", notes: [11,17.75,11,18,12.83,13,10.5,16,18,12],            total: 150.58, moy: 13.69 },
  { no: 30, prenom: "Alpha Oumar",              nom: "SOUMARE",     s: "M", notes: [6,15,14,20,15.67,12,10,14,18.25,12.5],             total: 149.42, moy: 13.58 },
  { no: 31, prenom: "Mariam",                   nom: "TOURE",       s: "F", notes: [12,17.75,14,14,10.17,12,17,17,19.25,7],            total: 148.92, moy: 13.54 },
  { no: 32, prenom: "Kadidja",                  nom: "SANOGO",      s: "M", notes: [5.5,16,10,18,15.83,12,16,17,18.5,10],              total: 148.33, moy: 13.48 },
  { no: 33, prenom: "Kibili Demba",             nom: "MACALOU",     s: "M", notes: [5,17,12.5,13.5,13.5,14,15,18,17.5,6],              total: 146.5,  moy: 13.32 },
  { no: 34, prenom: "Oumou Koulsoum",           nom: "CAMARA",      s: "F", notes: [8,15.25,12.5,16,17.17,9,11,17,16.25,11],           total: 145.42, moy: 13.22 },
  { no: 35, prenom: "Aminata Abdoulaye",        nom: "DESSOIH",     s: "F", notes: [7,16.25,13,18,12.5,9,15,17,17.25,9.5],             total: 144.75, moy: 13.16 },
  { no: 36, prenom: "Oumar",                    nom: "FANE",        s: "M", notes: [6,14.25,17,16,16.5,13,12,17,15.75,7],              total: 144.75, moy: 13.16 },
  { no: 37, prenom: "Safiatou",                 nom: "TEKETE",      s: "F", notes: [7,16.25,9.5,20,14.5,11,15.5,18,11.5,12],           total: 141.25, moy: 12.84 },
  { no: 38, prenom: "Mariam Makan",             nom: "SYLLA",       s: "F", notes: [7,16.25,9.5,20,14.5,11,15.5,18,11.5,12],           total: 141.25, moy: 12.84 },
  { no: 39, prenom: "Anta",                     nom: "DEMBELE",     s: "F", notes: [9,16.75,9.25,16,14.67,15,15,18,13.5,7],            total: 138.42, moy: 12.58 },
  { no: 40, prenom: "Ahmadou",                  nom: "SANOGO",      s: "M", notes: [5,17,13,10,14.5,13.5,11,12.5,18,19.5],             total: 136.92, moy: 12.45 },
  { no: 41, prenom: "Sibène Véronique",         nom: "KONE",        s: "F", notes: [9,12,9,17.5,13.67,13,8,18,19.5,7],                 total: 136.75, moy: 12.43 },
  { no: 42, prenom: "Dido dite Diawary",        nom: "KEÏTA",       s: "F", notes: [5,13.5,6,14,15.33,11,16,17,18.25,6],               total: 136.42, moy: 12.40 },
  { no: 43, prenom: "Isaac André",              nom: "SIDIBE",      s: "M", notes: [11,18.25,12,13,13.17,12,14,17,18.25,6],            total: 131.33, moy: 11.94 },
  { no: 44, prenom: "Mamadou Lamine",           nom: "BAGAYOGO",    s: "M", notes: [10,10.5,6.5,14,13.17,12,8,13,14,6],                total: 130.92, moy: 11.90 },
  { no: 45, prenom: "Hawa",                     nom: "KARAMBE",     s: "F", notes: [7,15.75,10,15.5,10.17,11,14,16,17.75,5],           total: 130.67, moy: 11.88 },
  { no: 46, prenom: "Mahamane Ibrahima",        nom: "CISSE",       s: "M", notes: [6,13.25,9.5,12,14.17,11,13.5,19,9.5,9],            total: 129.67, moy: 11.79 },
  { no: 47, prenom: "Abdoulaye",                nom: "KANE",        s: "M", notes: [9,16.25,6,18,13,8,12.5,14,16.25,7],                total: 125.92, moy: 11.45 },
  { no: 48, prenom: "Lamine",                   nom: "KONE",        s: "M", notes: [5.5,14.5,6.5,10,14,8,12,16,7.75,10],               total: 121.25, moy: 11.02 },
];

// ─── Calcul dynamique des largeurs ───────────────────────────────────────────
// Largeur d'une chaîne en pt = nb_caractères × CHAR_W + CELL_PAD

const textW = (str) => String(str).length * CHAR_W + CELL_PAD;

// Colonnes fixes : max entre le titre et la valeur la plus longue des données
const W_NO     = Math.max(textW("N°"),     ...STUDENTS.map((s) => textW(s.no)));
const W_PRENOM = Math.max(textW("Prénom"), ...STUDENTS.map((s) => textW(s.prenom)));
const W_NOM    = Math.max(textW("Nom"),    ...STUDENTS.map((s) => textW(s.nom)));
const W_SEXE   = Math.max(textW("Sexe"),   ...STUDENTS.map((s) => textW(s.s)));

const W_FIXED  = W_NO + W_PRENOM + W_NOM + W_SEXE;

// Colonnes variables (notes, total, moyenne) : max des données uniquement
// (le titre est vertical → n'impose pas la largeur)
const W_NOTE_DATA  = Math.max(...STUDENTS.flatMap((s) => s.notes.map((n) => textW(n))));
const W_TOTAL_DATA = Math.max(textW("TOTAL"),   ...STUDENTS.map((s) => textW(s.total)));
const W_MOY_DATA   = Math.max(textW("MOYENNE"), ...STUDENTS.map((s) => textW(s.moy)));

// Largeurs minimales des colonnes variables
const rawVar  = [...MATIERES.map(() => W_NOTE_DATA), W_TOTAL_DATA, W_MOY_DATA];
const sumRaw  = rawVar.reduce((a, b) => a + b, 0);

// Étirer proportionnellement pour remplir 100% de la page
const scale   = (PAGE_W - W_FIXED) / sumRaw;
const VAR_W   = rawVar.map((w) => w * scale);

// Correction d'arrondi sur la dernière colonne
const sumVar  = VAR_W.reduce((a, b) => a + b, 0);
VAR_W[VAR_W.length - 1] += (PAGE_W - W_FIXED) - sumVar;

const W_NOTES   = VAR_W.slice(0, MATIERES.length);  // 10 largeurs
const W_TOTAL   = VAR_W[MATIERES.length];
const W_MOYENNE = VAR_W[MATIERES.length + 1];

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  page: {
    paddingTop: 18,
    paddingBottom: 18,
    paddingHorizontal: 18,
    fontSize: FONT_SIZE,
    fontFamily: "Helvetica",
    backgroundColor: "#fff",
  },

  // ── En-tête institution ──────────────────────────────────────────────────
  headerRow:       { flexDirection: "row", alignItems: "center", marginBottom: 4 },
  logoBox:         { width: 36, height: 36, border: BORDER, borderRadius: 18, marginRight: 8, alignItems: "center", justifyContent: "center" },
  logoText:        { fontSize: 5, textAlign: "center", color: "#333" },
  headerTextBlock: { flex: 1, alignItems: "center" },
  headerTitle:     { fontSize: 8, fontFamily: "Helvetica-Bold", textAlign: "center", marginBottom: 1 },
  headerSubtitle:  { fontSize: 7, textAlign: "center", marginBottom: 1 },
  headerMention:   { fontSize: 7, textAlign: "center", fontFamily: "Helvetica-Bold" },

  // ── Tableau ──────────────────────────────────────────────────────────────
  table: { width: "100%", borderLeft: BORDER, borderTop: BORDER },
  row:   { flexDirection: "row" },

  // ── Cellule générique ────────────────────────────────────────────────────
  cell: {
    borderRight: BORDER,
    borderBottom: BORDER,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 1,
    paddingVertical: 1,
  },

  // ── Texte dans les cellules ──────────────────────────────────────────────
  cellText:     { fontSize: FONT_SIZE, textAlign: "center" },
  cellTextBold: { fontSize: FONT_SIZE, fontFamily: "Helvetica-Bold", textAlign: "center" },
  cellTextLeft: { fontSize: FONT_SIZE, textAlign: "left", paddingLeft: 2 },

  // ── Hauteur ligne d'en-tête ──────────────────────────────────────────────
  headerHeight: { height: HEADER_H },

  // ── Couleurs alternées ───────────────────────────────────────────────────
  rowEven:   { backgroundColor: "#EAF3FB" },
  rowOdd:    { backgroundColor: "#fff" },
  totalCell: { backgroundColor: TOTAL_BG },

  // ── Pied de page ─────────────────────────────────────────────────────────
  footer:     { marginTop: 8, flexDirection: "row", justifyContent: "space-between" },
  footerText: { fontSize: 7 },
});

// ─── Composants ──────────────────────────────────────────────────────────────

/** Cellule standard — inchangée */
const Cell = ({ style, children, textStyle }) => (
  <View style={[styles.cell, style]}>
    <Text style={[styles.cellText, textStyle]}>{children ?? ""}</Text>
  </View>
);

/**
 * Cellule d'en-tête avec texte tourné à -90° via <Canvas>.
 * Les 4 bordures sont dessinées dans le painter car <Canvas>
 * ignore les styles border CSS.
 */
const VerticalHeaderCell = ({ label, width, bg = HEADER_BG }) => {
  const painter = (p, w, h) => {
    // Fond
    p.rect(0, 0, w, h).fill(bg);

    // 4 bordures
    p.lineWidth(BORDER_W).strokeColor(BORDER_CLR);
    p.moveTo(0, 0).lineTo(w, 0).stroke(); // haut
    p.moveTo(0, h).lineTo(w, h).stroke(); // bas
    p.moveTo(w, 0).lineTo(w, h).stroke(); // droite
    p.moveTo(0, 0).lineTo(0, h).stroke(); // gauche

    // Texte tourné -90°, centré dans la cellule
    p.save();
    p.translate(w / 2, h / 2);
    p.rotate(-90);
    p.fontSize(FONT_SIZE)
     .font("Helvetica-Bold")
     .fillColor("#000000")
     .text(label, -(h / 2) + 4, -(FONT_SIZE / 2), {
       width:     h - 8,
       align:     "center",
       lineBreak: false,
     });
    p.restore();
  };

  return <Canvas style={{ width, height: HEADER_H }} paint={painter} />;
};

/** Ligne d'en-têtes */
const HeaderRow = () => (
  <View style={styles.row}>
    {/* Colonnes fixes — texte horizontal */}
    <Cell style={[{ width: W_NO },     styles.headerHeight, { backgroundColor: HEADER_BG }]}
          textStyle={{ fontFamily: "Helvetica-Bold" }}>N°</Cell>
    <Cell style={[{ width: W_PRENOM }, styles.headerHeight, { backgroundColor: HEADER_BG }]}
          textStyle={{ fontFamily: "Helvetica-Bold" }}>Prénom</Cell>
    <Cell style={[{ width: W_NOM },    styles.headerHeight, { backgroundColor: HEADER_BG }]}
          textStyle={{ fontFamily: "Helvetica-Bold" }}>Nom</Cell>
    <Cell style={[{ width: W_SEXE },   styles.headerHeight, { backgroundColor: HEADER_BG }]}
          textStyle={{ fontFamily: "Helvetica-Bold" }}>Sexe</Cell>

    {/* Colonnes matières — texte vertical via Canvas */}
    {MATIERES.map((m, i) => (
      <VerticalHeaderCell key={m} label={m} width={W_NOTES[i]} />
    ))}
    <VerticalHeaderCell label="TOTAL"   width={W_TOTAL}   />
    <VerticalHeaderCell label="MOYENNE" width={W_MOYENNE} />
  </View>
);

/** Ligne étudiant — inchangée */
const StudentRow = ({ student, index }) => {
  const bg = index % 2 === 0 ? styles.rowEven : styles.rowOdd;
  return (
    <View style={[styles.row, bg]}>
      <Cell style={[{ width: W_NO }]}     textStyle={{ fontFamily: "Helvetica-Bold" }}>{student.no}</Cell>
      <Cell style={[{ width: W_PRENOM }, { alignItems: "flex-start" }]}
            textStyle={styles.cellTextLeft}>{student.prenom}</Cell>
      <Cell style={[{ width: W_NOM },    { alignItems: "flex-start" }]}
            textStyle={[styles.cellTextLeft, { fontFamily: "Helvetica-Bold" }]}>{student.nom}</Cell>
      <Cell style={[{ width: W_SEXE }]}>{student.s}</Cell>
      {student.notes.map((n, i) => (
        <Cell key={i} style={{ width: W_NOTES[i] }}>{n}</Cell>
      ))}
      <Cell style={[{ width: W_TOTAL },   styles.totalCell]}
            textStyle={{ fontFamily: "Helvetica-Bold" }}>{student.total}</Cell>
      <Cell style={[{ width: W_MOYENNE }, styles.totalCell]}
            textStyle={{ fontFamily: "Helvetica-Bold" }}>{student.moy}</Cell>
    </View>
  );
};

// ─── Document PDF ─────────────────────────────────────────────────────────────

const ResultatsPharmaciePDF = ({ students = STUDENTS }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={styles.page}>

      {/* En-tête */}
      <View style={styles.headerRow}>
        <View style={styles.logoBox}>
          <Text style={styles.logoText}>UKMF</Text>
        </View>
        <View style={styles.headerTextBlock}>
          <Text style={styles.headerTitle}>
            UNIVERSITE KANKOU MOUSSA Faculté mixte des Sciences de la Santé (Médecine & Pharmacie)
          </Text>
          <Text style={styles.headerSubtitle}>
            Résultats des évaluations du 1er Semestre 2025-2026 – 4ème Année de Pharmacie
          </Text>
          <Text style={styles.headerMention}>
            Liste des Étudiants ayant validé la totalité des crédits du 1er Semestre
          </Text>
        </View>
      </View>

      {/* Tableau */}
      <View style={styles.table}>
        <HeaderRow />
        {students.map((s, i) => (
          <StudentRow key={s.no} student={s} index={i} />
        ))}
      </View>

      {/* Pied de page */}
      <View style={styles.footer}>
        <Text style={styles.footerText}>Bamako, le 21/02/2026</Text>
        <Text style={styles.footerText}>Président du jury</Text>
        <Text style={styles.footerText}>Le Recteur</Text>
      </View>

    </Page>
  </Document>
);

export default ResultatsPharmaciePDF;

export async function generatePDF(students = STUDENTS) {
  const blob = await pdf(
    <ResultatsPharmaciePDF students={students} />
  ).toBlob();
  const url = URL.createObjectURL(blob);
  const a   = document.createElement("a");
  a.href     = url;
  a.download = "resultats_pharmacie_S1_2025-2026.pdf";
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * ─── Structure d'un objet étudiant ──────────────────────────────────────────
 * {
 *   no:     number,
 *   prenom: string,
 *   nom:    string,
 *   s:      "F" | "M",
 *   notes:  number[10],   // dans l'ordre de MATIERES
 *   total:  number,
 *   moy:    number,
 * }
 */